import React, { useEffect, useState } from 'react';
import Layout from '../Layout/Layout';
import './abroad.css';
import { Table } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import request from '../../../api/api';
import { format } from 'date-fns';
import toast from 'react-hot-toast';

function Abroad() {
  // Placeholder data for demonstration
  const navigate = useNavigate()
   const [pages, setpages] = useState("");
      const [activePage, setactivePage] = useState(1);
      const [currPage, setcurrPage] = useState(25);
      const [pageRangeDisplayed, setpageRangeDisplayed] = useState(4);
  const [abroadList,setAbroadList] = useState([])
   const [tableOption, setTableOption] = useState({
        search: "",
        skip: 0,
        limit: 10,
        fromDate: "",
        toDate: "",
      });

      const getAllAbroadList = () => {
      request({
        url: "/abroad/admin/abroad/list",
        method: "POST",
        data: tableOption,
      }).then((res) => {
        if (res.status === 1) {
          setAbroadList(res.response.result);
          setpages(res.response.fullcount);
          setcurrPage(res.response.length);
        }else if (res && +res.status === 0) {
            setAbroadList(res.response.result);
            setpages(res.response.fullcount);
            setcurrPage(res.response.length);
          }
      });
    };

    useEffect(() => {
      getAllAbroadList();
    }, [tableOption]);


    const updateAbroadActiveStatus = (id,value)=>{
        if(!id){
          return toast.error("Select the Abroad")
        }

        request({
          url:`/abroad/admin/abroad/status/${id}`,
          method:'POST',
          data:{
            status:value
          }
        }).then((res)=>{
          if(res.status===1){
            toast.success("Status Updated")
            getAllAbroadList()
          }
          if(res.status===0){
            toast.error("Status not updated")
          }
        }).catch((err)=>{
          console.log(err)
        })
    }

   




  return (
    <Layout>
      <div className="abroad-header">
        <div className='text-end'>
          <button className="add_blog_btn" onClick={() => navigate('/abroad/add')}>Add Abroad Program</button>
        </div>
      </div>
      <div className="mybookings-table-wrap mt-4">
        <Table borderless className="mybookings-table">
          <thead style={{ "--bg-color": "#f3f5ff" }}>
            <tr style={{ "--text-color": "#8d9eff" }}>
              <th>S.No</th>
              <th>ID</th>
              <th>Country</th>
              <th>Created At</th>
              <th>Created By</th>
              <th>Order Placed</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {abroadList.length === 0 ? (
              <tr className="text-center">
                <td colSpan={6}>
                  <h6>No records available</h6>
                </td>
              </tr>
            ) : (
              abroadList.map((item, idx) => (
                <tr key={item?._id} className="cursor-pointer">
                  <td>{idx + 1}</td>
                  <td>{item?.route_id}</td>
                  <td>{item?.country_name}</td>
                  <td>{item?.createdAt ? format(new Date(item?.createdAt),'dd/MM/yyyy'):"-"}</td>
                  <td>{item?.createdByModel}</td>
                  <td>{item?.order}</td>
                  <td>
                    <div className="switch-container">
                      <input
                        type="checkbox"
                        checked={item?.status ?? false}
                        className="checkbox"
                        id={`checkbox-${item._id}`}
                        onChange={(e) =>
                          updateAbroadActiveStatus(item?._id, e.target.checked)
                        }
                      />
                      <label className="switch" htmlFor={`checkbox-${item._id}`}>
                        <span className="slider"></span>
                      </label>
                    </div>
                  </td>
                  <td className="action-space">
                    <span className="text-primary" title="View">
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    </span>
                    <span className="text-warning ms-2" title="Edit" onClick={()=>navigate('/abroad/add',{state:{abroad_id:item._id}})}>
                      <i className="fa fa-pencil" aria-hidden="true"></i>
                    </span>
                    <span className="action-btn ms-2" title="Delete">
                      <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </Layout>
  );
}

export default Abroad;
